// Admin-bucket pending member approvals — §5.3 / SC-6.
//
// Navigate-only CTA (obligation-light). No inline approve — that stays in Admin.

import type { PrimaryMode } from "@/components/lead/sections/LeadWorkspaceHeaderAccess";
import type { PendingMemberApprovalCounts } from "@/lib/admin/pendingMemberApprovalCount";
import { totalPendingMemberApprovals } from "@/lib/admin/pendingMemberApprovalCount";
import { formatPendingApprovalsBodyLine } from "./adminDockCopy";

export type ActivityDockPendingApprovalsSectionProps = {
  pendingMemberApprovalCounts: PendingMemberApprovalCounts | null;
  currentMode?: PrimaryMode | null;
  onOpenAdmin?: () => void;
};

export function ActivityDockPendingApprovalsSection({
  pendingMemberApprovalCounts,
  currentMode = null,
  onOpenAdmin,
}: ActivityDockPendingApprovalsSectionProps) {
  if (
    pendingMemberApprovalCounts === null ||
    totalPendingMemberApprovals(pendingMemberApprovalCounts) <= 0
  ) {
    return null;
  }

  const bodyLine = formatPendingApprovalsBodyLine(
    pendingMemberApprovalCounts,
    currentMode,
  );

  return (
    <section
      aria-label="Pending member approvals"
      className="mt-3 rounded-2xl border border-sky-300 bg-sky-50 px-3 py-3 text-left text-xs text-sky-900 dark:border-sky-700 dark:bg-sky-950/35 dark:text-sky-100"
    >
      <div className="flex items-center justify-between gap-2">
        <div className="min-w-0">
          <div className="text-[11px] font-semibold uppercase tracking-wide opacity-80">
            Member access
          </div>
          <p className="mt-1 text-[12px] leading-snug">{bodyLine}</p>
        </div>
        {onOpenAdmin ? (
          <button
            type="button"
            onClick={onOpenAdmin}
            className="shrink-0 rounded-lg bg-sky-700 px-2.5 py-1.5 text-[11px] font-semibold text-white hover:bg-sky-800 dark:bg-sky-600 dark:hover:bg-sky-500"
          >
            Open Admin
          </button>
        ) : null}
      </div>
    </section>
  );
}
